// @ts-check
import _ from 'lodash';

const PHOTO = 'foto';
const COMP = 'competencia';
const BRAND = 'brand';
let images = [];

const findImageByQuestion = (str) => {
  const image = images.find((img) => img.questionText === str);
  return image ? image.id : null;
};

const skuPostObj = (metaDataId, name) => ({
  meta_data: metaDataId,
  name_string: name,
  sku_string: null,
  dataPoints: [],
});

const skuKeyValue = (key, value) => ({
  key,
  value,
});

const cleanResponseVal = (val) => {
  if (!val) {
    return '';
  }

  if (Array.isArray(val) || typeof val === 'object') {
    return val[0];
  }

  return val;
};

export const parseQuestions = (data, keys) => {
  // a place to store the parsed question data
  const dataSets = {};
  keys.forEach((k) => {
    dataSets[k] = {};
    dataSets[`${k}_${PHOTO}`] = {};
    dataSets[`${k}_${COMP}`] = {};
    dataSets[`${k}_${BRAND}`] = {};
  });
  // array for the data post objects
  const skuPostData = [];
  // array for the UI display objects
  const productObjects = [];
  // array of product name strings
  const prodStrings = [];
  // array of non-product questions for UI
  const otherQuestions = [];
  // the raw questions from the submission
  const questions = JSON.parse(data.submission.submissionData);
  // the images from the submission. we'll be matching this to photo questions
  images = data.images;
  _.forIn(questions, (val, key, obj) => {
    const prodRegex = new RegExp(/'(.+)'/g);
    const compRegex = new RegExp(/''(.+)''/g);

    const match = prodRegex.exec(key);
    const compMatch = compRegex.exec(key);
    if (compMatch) {
      const compString = compMatch[1].toUpperCase();
      prodStrings.push(compString);
      keys.forEach((questionKey) => {
        if (key.toLowerCase().includes(questionKey)) {
          if (key.toLowerCase().includes(COMP)) {
            dataSets[`${questionKey}_${COMP}`][compString] =
              cleanResponseVal(val);
          } else {
            dataSets[`${questionKey}_${BRAND}`][compString] =
              cleanResponseVal(val);
          }
        }
      });
    } else if (match) {
      const prodString = match[1].toUpperCase();
      prodStrings.push(prodString);
      keys.forEach((questionKey) => {
        // first - is it product photo question ?
        if (
          key.toLowerCase().includes(questionKey) &&
          key.toLowerCase().includes(PHOTO)
        ) {
          dataSets[`${questionKey}_${PHOTO}`][prodString] =
            findImageByQuestion(key);

          // or just a regular product question?
        } else if (key.toLowerCase().includes(questionKey)) {
          dataSets[questionKey][prodString] = cleanResponseVal(val);
        }
      });
    } else {
      otherQuestions[key] = cleanResponseVal(val);
    }
  });
  // get the unique produce name strings
  const skus = _.uniq(prodStrings);

  // remove any empty data sets from the parsed data
  _.forIn(dataSets, (value, key) => {
    if (_.size(dataSets[key]) === 0) {
      _.unset(dataSets, key);
    }
  });

  skus.forEach((sku) => {
    const skuPost = skuPostObj(data.id, sku);
    const product = { nameString: sku };
    _.forIn(dataSets, (value, key) => {
      product[key] = value[sku];
      if (value[sku]) {
        skuPost.dataPoints.push(skuKeyValue(key, value[sku]));
      }
    });
    skuPostData.push(skuPost);
    productObjects.push(product);
  });
  return {
    skus: productObjects.length > 0 ? productObjects : [],
    other: otherQuestions,
    skuPostData,
  };
};
